import { render, staticRenderFns } from "./grid-empty-state.vue?vue&type=template&id=4e45e59a&scoped=true"
import script from "./grid-empty-state.vue?vue&type=script&lang=js"
export * from "./grid-empty-state.vue?vue&type=script&lang=js"
import style0 from "./grid-empty-state.vue?vue&type=style&index=0&id=4e45e59a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e45e59a",
  null
  
)

export default component.exports